import StylingInputs from 'component/StylingInputs'
import StylingPreview from 'component/StylingPreview'
import React from 'react'

const Styling = () => {

  return (
    <div className="bg-gray-50 min-h-screen flex items-start justify-center p-6">
      <div className="flex w-full  space-x-6">
        {/* LEFT SIDEBAR */}
        <StylingInputs/>

        {/* RIGHT SIDE (PHONE + BUTTONS) */}
      <StylingPreview/>
      </div>
    </div>
  )
}

export default Styling